<template>
  <div class="power">
    <div v-html="detailObj.claims"></div>
  </div>
</template>

<script>

export default {
  props: {
    detailObj: Object,
  },
  data() {
    return {
    }
  },
  components: {
  },
  watch: {
    detailObj() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {

    }

  }
}
</script>

<style scoped lang="scss">

</style>
